import { useContext, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SelectIdGroupContext } from '_context/SelectGroupContext'
import { setDashboardIsViewAll } from '_redux/modules/dashboard'
import SalesAndFulfilment from './components/SalesAndFulfilment'
import Analytics from './components/Analytics'
import ProductsAndMembers from './components/ProductsAndMembers'
import DashboardHeader from './components/DashboardHeader'
import FilterBar from './components/FilterBar'
import Overview from './components/Overview'
import useDashboardFilters from './hooks/useDashboardFilters'
import EventsReport from './components/EventsReport'
import { useDashboardData } from './hooks/useDataDashboard'
import './style.scss'
import { getGroupIdSelected } from '../../utils/localData'
import { useDataEventsSection } from './hooks/useDataEventsSection'

export default function DashboardDesktop() {
  const dispatch = useDispatch()
  const isViewAll = useSelector((state) => state.dashBoard.isViewAll) || false

  const context = useContext(SelectIdGroupContext)
  const { groupId } = context.infoGroupSelected
  const selectedGroupId = useMemo(() => groupId || getGroupIdSelected(), [groupId])

  const setIsViewAll = (value) => dispatch(setDashboardIsViewAll(value, selectedGroupId))

  const { filters, updateFilter, resetFilters } = useDashboardFilters(selectedGroupId)
  const { data, loading } = useDashboardData(selectedGroupId, filters, isViewAll)
  const { dataEvents, loadingEvents } = useDataEventsSection(selectedGroupId)
  const events = useMemo(() => {
    const rawEvents = data?.eventReport?.eventStatus || []
    return rawEvents.map((item) => ({
      id: item.eId,
      title: item.eName,
    }))
  }, [data?.eventReport?.eventStatus])

  const eventTimeRange = useMemo(() => {
    const handleEvent = data?.eventReport?.eventStatus || []
    if (!handleEvent.length) return null
    const timestamps = handleEvent
      .map((e) => e.createdAt)
      .filter((t) => typeof t === 'number' && t > 0)
    if (!timestamps.length) return null
    return {
      start: Math.min(...timestamps),
      end: Math.max(...timestamps),
    }
  }, [data?.eventReport?.eventStatus])

  return (
    <div className='container-dashboard'>
      <div id='dashboard'>
      <DashboardHeader
        filters={filters}
        events={events}
        isViewAll={isViewAll}
        setIsViewAll={setIsViewAll}
        selectedGroupId={selectedGroupId}
      />
      <FilterBar
        filters={filters}
        updateFilter={updateFilter}
        resetFilters={resetFilters}
        events={events}
      />
      <Overview
        summaryReport={data?.summaryReport}
        hitpayReport={data?.hitpayReport}
        loading={loading}
        filters={filters}
        isViewAll={isViewAll}
        eventTimeRange={eventTimeRange}
      />

      <Analytics
        eventReport={data?.eventReport}
        loading={loading}
        isViewAll={isViewAll}
        filters={filters}
        eventTimeRange={eventTimeRange}
      />
      <SalesAndFulfilment
        revenueReport={data?.revenueReport}
        loading={loading}
        filters={filters}
        isViewAll={isViewAll}
        eventTimeRange={eventTimeRange}
      />
      <ProductsAndMembers
        eventReport={data?.eventReport}
        productReport={data?.productReport}
        buyerReport={data?.buyerReport}
        loading={loading}
        isViewAll={isViewAll}
        filters={filters}
        eventTimeRange={eventTimeRange}
      />
      <EventsReport
        dataEvents={dataEvents}
        data={data}
        loadingEvents={loadingEvents}
        isViewAll={isViewAll}
        filters={filters}
        eventTimeRange={eventTimeRange}
      />
      </div>
    </div>
  )
}
